
import { computed, defineComponent, PropType, toRef } from 'vue'
import { PPTSvgElement } from '@/types/slides'
import useElementOutline from '@/views/components/element/hooks/useElementOutline'
import useElementShadow from '@/views/components/element/hooks/useElementShadow'
import useElementFlip from '@/views/components/element/hooks/useElementFlip'
import tinycolor from 'tinycolor2'
export default defineComponent({
  name: 'base-element-svg',
  props: {
    elementInfo: {
      type: Object as PropType<PPTSvgElement>,
      required: true,
    },
  },
  setup(props) {
    const outline = computed(() => props.elementInfo.outline)
    const { outlineWidth, outlineStyle, outlineColor } = useElementOutline(outline)
    
    const shadow = computed(() => props.elementInfo.shadow)
    const { shadowStyle } = useElementShadow(shadow)

    const flipH = computed(() => props.elementInfo.flipH)
    const flipV = computed(() => props.elementInfo.flipV)
    const { flipStyle } = useElementFlip(flipH, flipV)
    const elementInfo = toRef(props, 'elementInfo')
    let path = elementInfo.value.path
    elementInfo.value.colors.forEach((item, ind) => {
      const items = tinycolor(item) as never
      path = path.replaceAll('color[' + ind + ']', items)
    })
    elementInfo.value.svg = path
    return {
      shadowStyle,
      outlineWidth,
      outlineStyle,
      outlineColor,
      flipStyle
    }
  },
})
